export default "__VITE_ASSET__B$3w9Ptu__"